import React from "react";
import { FiAlertCircle, FiInbox, FiSearch } from "react-icons/fi";

export const PageContainer = ({ children, className = "" }) => <div className={`pageContainer ${className}`}>{children}</div>;

export const PageHeader = ({ eyebrow, title, description, actions }) => (
  <div className="pageHeading">
    <div>{eyebrow && <span className="pageEyebrow">{eyebrow}</span>}<h1>{title}</h1>{description && <p>{description}</p>}</div>
    {actions && <div className="pageHeading__actions">{actions}</div>}
  </div>
);

export const SectionCard = ({ title, description, actions, children, className = "" }) => (
  <section className={`adminSectionCard ${className}`}>
    {(title || actions) && <header><div><h2>{title}</h2>{description && <p>{description}</p>}</div>{actions}</header>}
    <div className="adminSectionCard__body">{children}</div>
  </section>
);

export const SearchInput = ({ className = "", ...props }) => <label className={`adminSearch ${className}`}><FiSearch aria-hidden="true" /><input {...props} /></label>;

export const StatusBadge = ({ children, status = "neutral" }) => <span className={`statusBadge statusBadge--${String(status).toLowerCase().replace(/\s+/g, "-")}`}>{children}</span>;

export const EmptyState = ({ title = "No records found", description = "There is no information to display.", action }) => (
  <div className="adminEmptyState"><FiInbox /><h3>{title}</h3><p>{description}</p>{action}</div>
);

export const ErrorState = ({ title = "Unable to load data", description, action }) => (
  <div className="adminErrorState"><FiAlertCircle /><h3>{title}</h3>{description && <p>{description}</p>}{action}</div>
);

export const LoadingSkeleton = ({ rows = 3 }) => <div className="adminSkeleton" aria-label="Loading">{Array.from({ length: rows }, (_, index) => <span key={index} />)}</div>;

export const FormActions = ({ children, sticky = false }) => <div className={`formActions ${sticky ? "formActions--sticky" : ""}`}>{children}</div>;
